<template>
  <div id="senior-member-edit">
    <v-dialog v-model="showDialog" persistent scrollable max-width="1200px">
      <v-card>
        <v-app-bar color="primary" dense dark elevate-on-scroll>
          <v-toolbar-title>JAC Member Region Update</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closePrompt">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-text class="pt-6">
          <v-card outlined class="mb-6">
            <v-card-title class="subtitle-1 font-weight-bold"
              >Member Details</v-card-title
            >
            <v-card-text>
              <v-row v-if="recordData">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  class="text-center"
                  v-if="recordData.ProfilePic"
                >
                  <img
                    width="150"
                    height="150"
                    style="
                      object-fit: cover;
                      border-radius: 8px;
                      border: 2px solid #e2e8f0;
                    "
                    :src="recordData.ProfilePic"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Member Name</label>
                  <h5 class="info-value">{{ recordData.MemberName || "-" }}</h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Membership Id</label>
                  <h5 class="info-value">
                    {{ recordData.MembershipId || "-" }}
                  </h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Status</label>
                  <div class="mt-1">
                    <v-chip
                      :color="recordData.LomStatusColor || 'primary'"
                      text-color="white"
                      small
                      label
                    >
                      {{
                        recordData.LomStatusColor === "red"
                          ? "Disaffiliated"
                          : "Active"
                      }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Zone</label>
                  <h5 class="info-value">{{ recordData.ZoneName || "-" }}</h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Region</label>
                  <h5 class="info-value">{{ recordData.RegionName || "-" }}</h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">LO Name</label>
                  <h5
                    class="info-value"
                    :class="{
                      'text-danger': recordData.LomStatusColor === 'red',
                    }"
                  >
                    {{ recordData.LomName || "-" }}
                  </h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Mobile No</label>
                  <h5 class="info-value">{{ recordData.MobileNo || "-" }}</h5>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <label class="info-label">Email</label>
                  <h5 class="info-value">{{ recordData.EmailId || "-" }}</h5>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <label class="info-label">Address</label>
                  <h5 class="info-value">
                    {{ recordData.AddressTxt || "-" }}
                  </h5>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card outlined>
            <v-card-title class="subtitle-1 font-weight-bold"
              >Update Region</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <div class="filter-label-wrapper">
                    <label class="info-label">Zone</label>
                  </div>
                  <v-autocomplete
                    @change="getRegionOptions(false)"
                    :items="ZoneCodeOptions"
                    v-model="ZoneCode"
                    dense
                    clearable
                    outlined
                    class="mt-2"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="filter-label-wrapper">
                    <label class="info-label">Region</label>
                  </div>
                  <v-autocomplete
                    :items="RegionCodeOptions"
                    v-model="RegionCode"
                    dense
                    clearable
                    outlined
                    class="mt-2"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="px-6"
            @click="RegionUpdate"
            :disabled="!isValid"
            :loading="UpdateFlag"
            >Update</v-btn
          >
          <v-btn color="error" class="px-6" @click="closePrompt">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  name: "SeniorMemberMembershipReportRegionEdit",
  mixins: [common],
  props: {
    EditRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      type: Object,
      required: true,
    },
    listZoneCode: {
      required: false,
    },
  },
  data() {
    return {
      showDialog: false,
      ZoneCode: "",
      ZoneCodeOptions: [],
      RegionCode: "",
      RegionCodeOptions: [],
      UpdateFlag: false,
    };
  },
  computed: {
    isValid() {
      return !!this.ZoneCode && !!this.RegionCode && !this.UpdateFlag;
    },
  },
  watch: {
    EditRecordPrompt(val) {
      this.showDialog = val;
    },
  },
  mounted() {
    this.showDialog = this.EditRecordPrompt;
    if (this.listZoneCode) {
      this.ZoneCode = this.listZoneCode;
      this.getRegionOptions(true);
    } else if (this.recordData.ZoneId) {
      this.ZoneCode = this.recordData.ZoneId;
      this.getRegionOptions(true);
    }
    this.getZoneOptions();
  },
  methods: {
    getZoneOptions() {
      console.log("getZoneOptions called");
      this.ZoneCodeOptions = [];

      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/jac-region/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getRegionOptions(isInitialLoad = false) {
      console.log("getRegionOptions called for Zone:", this.ZoneCode);

      if (isInitialLoad === true && this.recordData.RegionId) {
        this.RegionCode = this.recordData.RegionId;
      } else {
        this.RegionCode = "";
      }
      var selectbox2_source = "RegionCode";
      var selectbox2_destination = "RegionCodeOptions";
      var selectbox2_url = "api/jac-region/options";
      var selectbox2_conditions_array = {
        UserInterface: 1,
        Zone: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox2_source,
        selectbox2_destination,
        selectbox2_conditions_array,
        selectbox2_url
      );
    },
    RegionUpdate() {
      if (!this.isValid) return;

      this.UpdateFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/senior-members/region-update";

      var upload = {
        UserInterface: 1,
        Order: this.recordData.SmOrderId,
        Region: this.RegionCode,
      };

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.UpdateFlag = false;
          var output = response.data.output;
          var flag = response.data.flag;

          if (flag == 1) {
            thisIns.toast("success", output);
            thisIns.$emit("hideEditRecordPrompt", true);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.UpdateFlag = false;
          thisIns.toast("error", error);
        });
    },
    closePrompt() {
      this.$emit("hideEditRecordPrompt", false);
    },
  },
};
</script>

<style scoped>
.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.info-value {
  font-size: 15px;
  margin-top: 4px;
  color: #2c3e50;
  word-break: break-word;
}
.text-danger {
  color: #d32f2f !important;
}
</style>